import {Type} from '@angular/core';
import {GroupEstimateComponent} from '../../../modules/routing/group-estimate/group-estimate.component';

export class TypeOfEstimation {
  public readonly list: readonly {name:string, href:string, right: string, component: Type<any>, icon: string}[]= [
    { name: 'группы замечаний', href: 'group', right: 'rategroup', component: GroupEstimateComponent, icon: 'groupSVG'},
    { name: 'подгруппы замечаний', href: 'subgroup', right: 'ratesubgroup', component: GroupEstimateComponent, icon: 'subgroupSVG'},
    { name: 'виды замечаний', href: 'kind', right: 'ratekind', component: GroupEstimateComponent, icon: 'kindSVG'},
    { name: 'замечания', href: 'remarktype', right: 'remarktype', component: GroupEstimateComponent, icon: 'remarktypeSVG'},
    { name: 'категории проверок', href: 'ratecategory', right: 'ratecategory', component: GroupEstimateComponent, icon: 'ratecategorySVG'},
  ] as const;
}
